<div class="tw-bg-white">

<!-- HERO -->
<section class="tw-relative tw-overflow-hidden tw-bg-gradient-to-br tw-from-slate-900 tw-via-blue-950 tw-to-slate-900 tw-text-white tw-pt-20 tw-pb-32 tw-px-4">
  <div class="tw-absolute tw-inset-0 tw-opacity-10"
       style="background-image:radial-gradient(circle at 20% 50%,#3b82f6 0%,transparent 50%),radial-gradient(circle at 80% 20%,#1d4ed8 0%,transparent 40%)"></div>
  <div class="tw-max-w-6xl tw-mx-auto tw-relative">
    <div class="tw-text-center tw-mb-10">
      <span class="tw-inline-flex tw-items-center tw-gap-2 tw-bg-blue-500/20 tw-border tw-border-blue-400/30 tw-rounded-full tw-px-4 tw-py-1.5 tw-text-sm tw-text-blue-300 tw-mb-6">
        <span class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-blue-400 tw-animate-pulse"></span>
        Match con IA · Vacantes actualizadas diariamente
      </span>
      <h1 class="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-leading-tight tw-mb-4 tw-text-white">
        Tu próximo empleo <span class="tw-bg-gradient-to-r tw-from-blue-400 tw-to-cyan-300 tw-bg-clip-text tw-text-transparent">tech</span>,<br>encontrado por IA.
      </h1>
      <p class="tw-text-lg tw-text-slate-300 tw-max-w-2xl tw-mx-auto">
        Cientos de empleos tech al día, actualizados y listos para postularte.
        <ng-container *ngIf="estadisticas?.vacantes">{{estadisticas.vacantes}} vacantes activas ahora mismo.</ng-container>
      </p>
    </div>

    <!-- Stats bar -->
    <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-10" style="grid-template-columns: repeat(4, 1fr)">
      <div class="tw-text-center tw-rounded-2xl tw-p-4 tw-border tw-border-white/10 tw-bg-white/5">
        <div class="tw-text-3xl tw-font-bold tw-text-white">{{estadisticas?.vacantes || 0}}</div>
        <div class="tw-text-sm tw-text-slate-400 tw-mt-1">Vacantes activas</div>
      </div>
      <div class="tw-text-center tw-rounded-2xl tw-p-4 tw-border tw-border-white/10 tw-bg-white/5">
        <div class="tw-text-3xl tw-font-bold tw-text-white">{{estadisticas?.empresa || 0}}</div>
        <div class="tw-text-sm tw-text-slate-400 tw-mt-1">Empresas</div>
      </div>
      <div class="tw-text-center tw-rounded-2xl tw-p-4 tw-border tw-border-white/10 tw-bg-white/5">
        <div class="tw-text-3xl tw-font-bold tw-text-white">{{estadisticas?.usuarios || 0}}</div>
        <div class="tw-text-sm tw-text-slate-400 tw-mt-1">Candidatos</div>
      </div>
      <div class="tw-text-center tw-rounded-2xl tw-p-4 tw-border tw-border-white/10 tw-bg-white/5">
        <div class="tw-text-3xl tw-font-bold tw-text-white">{{estadisticas?.contratados || 0}}</div>
        <div class="tw-text-sm tw-text-slate-400 tw-mt-1">Contratados</div>
      </div>
    </div>
  </div>
</section>

<!-- SEARCH CARD (estilo Skyscanner: tarjeta flotante con todos los filtros clave) -->
<section class="tw-px-4" style="margin-top:-64px;position:relative;z-index:5;">
  <div class="tw-max-w-5xl tw-mx-auto">
    <form (ngSubmit)="buscarVacante()"
          class="tw-bg-white tw-rounded-2xl tw-p-4"
          style="box-shadow:0 12px 40px rgba(0,0,0,.18);">
      <div class="tw-grid tw-gap-3" style="grid-template-columns: 2fr 1fr 1fr auto;">
        <input type="text" [(ngModel)]="busquedaTitulo" name="titulo"
               placeholder="Vacante, cargo o puesto - Ej: Consultor, Arquitecto, Developer"
               class="tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-text-slate-800"
               style="min-height:auto;background:#f9fafb;">
        <select [(ngModel)]="paisBusqueda" name="pais"
                class="tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-text-slate-800"
                style="min-height:auto;background:#f9fafb;cursor:pointer;">
          <option value="">País</option>
          <option *ngFor="let p of paises" [value]="p">{{p}}</option>
        </select>
        <select [(ngModel)]="categoriaBusqueda" name="categoriaBusqueda"
                class="tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-text-slate-800"
                style="min-height:auto;background:#f9fafb;cursor:pointer;">
          <option [ngValue]="0">Categoría</option>
          <option *ngFor="let cat of categoriasEmpleos" [ngValue]="cat.idCategoria">{{cat.nombreCategoria}}</option>
        </select>
        <button type="submit"
                class="tw-px-6 tw-py-3 tw-rounded-xl tw-font-semibold tw-text-white tw-transition tw-whitespace-nowrap tw-border-0"
                style="background:#0066ff;cursor:pointer;">
          Buscar
        </button>
      </div>
    </form>

    <!-- Accesos rápidos por categoría -->
    <div class="tw-flex tw-flex-wrap tw-gap-2 tw-justify-center tw-mt-5" *ngIf="categoriasEmpleos?.length">
      <a *ngFor="let cat of categoriasEmpleos"
         (click)="filtroPorCategoria(cat.idCategoria, cat.nombreCategoria)"
         class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-semibold tw-cursor-pointer tw-transition"
         style="background:rgba(255,255,255,.9);color:#334155;border:1px solid #e5e7eb;text-decoration:none;">
        <img *ngIf="cat.icono" [src]="cat.icono" [alt]="cat.nombreCategoria" style="width:14px;height:14px;object-fit:cover;border-radius:3px;">
        {{cat.nombreCategoria}}
      </a>
    </div>
  </div>
</section>

<!-- GURUMATCH GRATIS BANNER -->
<section class="tw-px-4 tw-pt-8">
  <div class="tw-max-w-6xl tw-mx-auto">
    <a *ngIf="!usuarioRol && showFreeBanner" routerLink="/acceder" [queryParams]="{returnUrl: '/free-onboarding'}"
       class="tw-flex tw-items-center tw-gap-2 sm:tw-gap-3 tw-p-3 sm:tw-p-4 tw-rounded-2xl tw-text-white tw-no-underline"
       style="background: linear-gradient(135deg, #6366f1, #4f46e5); cursor:pointer;">
      <div class="tw-p-2 sm:tw-p-3 tw-rounded-xl tw-flex-shrink-0" style="background: rgba(255,255,255,.15);">
        <svg class="tw-w-5 tw-h-5 sm:tw-w-6 sm:tw-h-6 tw-text-white" fill="currentColor" viewBox="0 0 448 512">
          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
        </svg>
      </div>
      <div class="tw-flex-1 tw-min-w-0">
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
          <span class="tw-font-bold tw-text-xs sm:tw-text-sm">GuruMatch</span>
          <span class="tw-px-2 tw-py-0.5 tw-rounded-md tw-text-2xs sm:tw-text-xs tw-font-bold" style="background: rgba(251,191,36,.2); color: #fcd34d;">GRATIS</span>
        </div>
        <p class="tw-text-2xs sm:tw-text-xs tw-mt-0.5 tw-mb-0 tw-leading-tight" style="color: rgba(255,255,255,.7);">
          Sube tu CV y recibe en tu WhatsApp qué vacantes son compatibles contigo
        </p>
      </div>
      <span class="tw-px-3 sm:tw-px-4 tw-py-1.5 sm:tw-py-2 tw-rounded-xl tw-text-2xs sm:tw-text-xs tw-font-bold tw-bg-white tw-flex-shrink-0"
            style="color:#4f46e5; white-space:nowrap;">
        Ver vacantes
      </span>
    </a>
    <a *ngIf="usuarioRol && showFreeBanner" routerLink="/free-onboarding"
       class="tw-flex tw-items-center tw-gap-2 sm:tw-gap-3 tw-p-3 sm:tw-p-4 tw-rounded-2xl tw-text-white tw-no-underline"
       style="background: linear-gradient(135deg, #6366f1, #4f46e5); cursor:pointer;">
      <div class="tw-p-2 sm:tw-p-3 tw-rounded-xl tw-flex-shrink-0" style="background: rgba(255,255,255,.15);">
        <svg class="tw-w-5 tw-h-5 sm:tw-w-6 sm:tw-h-6 tw-text-white" fill="currentColor" viewBox="0 0 448 512">
          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
        </svg>
      </div>
      <div class="tw-flex-1 tw-min-w-0">
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
          <span class="tw-font-bold tw-text-xs sm:tw-text-sm">GuruMatch</span>
          <span class="tw-px-2 tw-py-0.5 tw-rounded-md tw-text-2xs sm:tw-text-xs tw-font-bold" style="background: rgba(251,191,36,.2); color: #fcd34d;">GRATIS</span>
        </div>
        <p class="tw-text-2xs sm:tw-text-xs tw-mt-0.5 tw-mb-0 tw-leading-tight" style="color: rgba(255,255,255,.7);">
          Sube tu CV y recibe en tu WhatsApp qué vacantes son compatibles contigo
        </p>
      </div>
      <span class="tw-px-3 sm:tw-px-4 tw-py-1.5 sm:tw-py-2 tw-rounded-xl tw-text-2xs sm:tw-text-xs tw-font-bold tw-bg-white tw-flex-shrink-0"
            style="color:#4f46e5; white-space:nowrap;">
        Probar ahora
      </span>
    </a>
  </div>
</section>

<!-- RECENT JOBS -->
<section class="tw-pt-12 tw-pb-16 tw-px-4">
  <div class="tw-max-w-6xl tw-mx-auto">
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-8">
      <div>
        <h2 class="tw-text-3xl tw-font-bold tw-text-slate-900">Vacantes recientes</h2>
        <p class="tw-text-slate-500 tw-mt-1">Oportunidades tech publicadas recientemente</p>
      </div>
      <a routerLink="/vacantes" class="tw-items-center tw-gap-2 tw-font-semibold tw-transition tw-hidden" style="display:flex; color:#1d4ed8; text-decoration:none">
        Ver todas
        <svg class="tw-w-4 tw-h-4" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clip-rule="evenodd"/>
        </svg>
      </a>
    </div>

    <div *ngIf="mensajeError" class="tw-text-center tw-py-4 tw-text-red-500 tw-text-sm">{{mensajeError}}</div>

    <div class="tw-grid tw-gap-5" style="grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))">
      <div *ngFor="let v of (vacantes | slice:0:12)"
           class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-5 tw-flex tw-flex-col tw-gap-3"
           style="box-shadow: 0 1px 3px rgba(0,0,0,.08); transition: box-shadow .2s">
        <div class="tw-flex tw-items-start tw-gap-3">
          <div class="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-slate-100 tw-flex-shrink-0 tw-overflow-hidden">
            <img [src]="v.logo || defaultLogo" [alt]="v.nombreEmpresa"
                 class="tw-w-full tw-h-full tw-object-cover"
                 (error)="onImageError($event)">
          </div>
          <div class="tw-flex-1 tw-min-w-0">
            <p class="tw-text-xs tw-text-slate-400 tw-truncate">{{v.nombreEmpresa}}</p>
            <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-leading-snug tw-truncate">{{v.nombre}}</h3>
          </div>
          <span *ngIf="v.etiqueta"
                class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-flex-shrink-0"
                style="background:#eff6ff; color:#0066ff">
            {{v.etiqueta}}
          </span>
        </div>
        <div class="tw-flex tw-flex-wrap tw-gap-1.5">
          <span *ngIf="v.tipoContrato" class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-slate-100 tw-text-slate-600 tw-text-xs">{{v.tipoContrato}}</span>
          <span *ngIf="v.salarioMin" class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium" style="background:#ecfdf5; color:#065f46">
            {{formatSalario(v.salarioMin + '')}} - {{formatSalario(v.salarioMax + '')}}
          </span>
        </div>
        <p class="tw-text-xs tw-text-slate-500 tw-flex-1" style="display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden">
          {{v.descripcion | stripHtml | slice:0:120}}
        </p>
        <p *ngIf="v.fechaCreado" class="tw-text-xs tw-text-slate-400">
          Publicado: {{ v.fechaCreado | appDate:'dd/MM/yyyy' }}
        </p>
        <a (click)="verDetalles(v)"
           class="tw-mt-auto tw-w-full tw-py-2 tw-rounded-xl tw-text-white tw-text-xs tw-font-semibold tw-text-center tw-transition tw-cursor-pointer tw-block"
           style="background:#0066ff; text-decoration:none">
          Ver detalles
        </a>
      </div>
    </div>

    <div class="tw-text-center tw-mt-8">
      <a routerLink="/vacantes"
         class="tw-inline-flex tw-items-center tw-gap-2 tw-px-6 tw-py-3 tw-rounded-xl tw-border tw-border-slate-200 tw-font-medium tw-text-slate-700 tw-transition"
         style="text-decoration:none">
        Ver todas las vacantes
      </a>
    </div>
  </div>
</section>

<!-- GURUMATCH PROMO -->
<section class="tw-py-16 tw-px-4 tw-text-white" style="background: linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)">
  <div class="tw-max-w-4xl tw-mx-auto tw-text-center">
    <div class="tw-inline-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-rounded-2xl tw-mb-6 tw-border tw-border-white/20"
         style="background: rgba(59,130,246,0.2)">
      <svg class="tw-w-8 tw-h-8" style="color:#60a5fa" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
      </svg>
    </div>
    <h2 class="tw-text-3xl tw-font-extrabold tw-text-white tw-mb-4">GuruMatch — IA que entiende tu CV</h2>
    <p class="tw-text-lg tw-max-w-2xl tw-mx-auto tw-mb-8" style="color:#cbd5e1">
      Sube tu CV, y nuestro motor de IA lo compara automáticamente con cada vacante del mercado. Recibes solo las que coinciden con tu stack.
    </p>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-justify-center" style="flex-direction:row; flex-wrap:wrap">
      <ng-container *ngIf="!usuarioRol">
        <a routerLink="/registrarse"
           class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-semibold tw-transition tw-border-0 tw-text-white"
           style="background:#0066ff; text-decoration:none">
          Empieza gratis
        </a>
      </ng-container>
      <ng-container *ngIf="usuarioRol">
        <a routerLink="/vacantes"
           class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-semibold tw-transition tw-border-0 tw-text-white"
           style="background:#0066ff; text-decoration:none">
          Ver vacantes
        </a>
      </ng-container>
      <a routerLink="/vacantes"
         class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-medium tw-transition"
         style="border: 1px solid rgba(255,255,255,.2); text-decoration:none; color:#fff">
        Explorar vacantes
      </a>
    </div>
  </div>
</section>

<!-- FINAL CTA -->
<section class="tw-py-16 tw-px-4 tw-bg-slate-50">
  <div class="tw-max-w-3xl tw-mx-auto tw-text-center">
    <h2 class="tw-text-3xl tw-font-bold tw-text-slate-900 tw-mb-4">¿Listo para dar el siguiente paso?</h2>
    <p class="tw-text-slate-500 tw-mb-8 tw-text-lg">Únete a miles de profesionales tech que ya encontraron su empleo ideal en TecGurus.</p>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-justify-center" style="flex-direction:row; flex-wrap:wrap">
      <ng-container *ngIf="!usuarioRol">
        <a routerLink="/registrarse"
           class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-semibold tw-text-white tw-transition"
           style="background:#0066ff; text-decoration:none">
          Registrarse gratis
        </a>
      </ng-container>
      <ng-container *ngIf="usuarioRol">
        <a routerLink="/mis-cvs"
           class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-semibold tw-text-white tw-transition"
           style="background:#0066ff; text-decoration:none">
          Ir a mis CVs
        </a>
      </ng-container>
      <a routerLink="/vacantes"
         class="tw-px-8 tw-py-3 tw-rounded-xl tw-font-medium tw-transition tw-border tw-border-slate-200 tw-text-slate-700"
         style="text-decoration:none">
        Ver vacantes
      </a>
    </div>
  </div>
</section>

</div>
